// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SELL_EXP_POPUP_BUTTON_LATER = "Teraz nie";
export const BZ2_SELL_EXP_POPUP_BUTTON_WRITE = "Nap\u00edsa\u0165 sk\u00fasenos\u0165";
export const BZ2_SELL_EXP_POPUP_TEXT = "Pom\u00f4\u017e \u010fal\u0161\u00edm a nap\u00ed\u0161, \u010do ti na \u0148om vyhovovalo aj \u010do nie.";
export const BZ2_SELL_EXP_POPUP_TITLE = "Pozn\u00e1\u0161 tento produkt z vlastnej sk\u00fasenosti?";
